import { Box, Divider, Typography } from '@mui/material';
import React from 'react';
import LabelsAndElements, { LabelAndElementRow } from '../LabelsAndElements/LabelsAndElements';
import ImagesCarousel from '../ImagesCarousel/ImagesCarousel';

interface Section {
    rows: Array<LabelAndElementRow>;
    title?: string;
    titleTypeSecondary?: boolean;
    separator?: boolean;
}
interface ImageDetailsProps {
    sections: Array<Section>;
    sources: Array<string>;
    imageProps?: any;
}

const ImageDetails: React.FC<ImageDetailsProps> = ({ sections, sources, imageProps }) => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', height: '97%' }}>
            <Box sx={{ minWidth: '50%', mr: 3, display: 'flex', flexDirection: 'column', overflow: 'auto' }}>
                {sections.map((section, index) => {
                    return (
                        <Box key={index}>
                            {section.separator && <Divider sx={{ mt: 3, mb: 3 }} />}
                            {section.title && (
                                <Typography
                                    variant="body1"
                                    sx={
                                        section.titleTypeSecondary
                                            ? { fontSize: '16px', fontWeight: '500', mb: 3 }
                                            : { fontWeight: '700', mb: 4 }
                                    }
                                >
                                    {section.title}
                                </Typography>
                            )}
                            <LabelsAndElements rows={section.rows} />
                        </Box>
                    );
                })}
            </Box>
            <ImagesCarousel
                containerStyles={{ maxHeight: 410 }}
                items={sources.map((src) => ({
                    src: src,
                    imageProps: {
                        roundedCorners: true,
                        contain: true,
                        ...(imageProps ? imageProps : {}),
                    },
                }))}
            />
        </Box>
    );
};

export default ImageDetails;
